import React, { Component } from 'react';
import { withRouter } from 'react-router-dom'
import "react-table/react-table.css";

import ProfileXiService from '../services/ProfileXiService';

class ProfileXiCard extends Component {
  constructor () {
    super();
    this.state = {
      isMounted: false,
      profileXi: {}
    };
  }

  componentDidMount () {
    this.setState({
      isMounted: true,
    }, () => {
      if (this.props.profileXiId !== undefined && this.props.profileXiId !== null) {
        ProfileXiService.fetchProfileXiById(this.props.profileXiId).then(data => {
          //console.log('ProfileXi', data)
          if(this.state.isMounted) {
            this.setState({
                profileXi: data
            });
          }
        });
      }
    });
  }

  componentWillUnmount(){
    this.setState({
      isMounted: false,
    });
  }

  render() {
    if (this.props.profileXiId === undefined || this.state.profileXi === undefined || this.state.profileXi === null || this.state.profileXi.ten == undefined){
      return (<></>);
    }
    return (
      <table width="100%" border="0" cellPadding="0" cellSpacing="0">
        <tbody>
          <tr>
            <td width="50%">
              Tên: 
            </td>
            <td>
              {this.state.profileXi.ten}
            </td>
          </tr>
          <tr>
            <td width="50%">
              Vol: 
            </td>
            <td>
              {this.state.profileXi.vol}
            </td>
          </tr>
          <tr>
            <td width="50%">
              Thời gian: 
            </td>
            <td>
              {this.state.profileXi.thoiGian}
            </td>
          </tr>
          <tr>
            <td width="50%">
              Nhiệt độ: 
            </td>
            <td>
              {this.state.profileXi.nhietDo}
            </td>
          </tr>
          <tr>
            <td width="50%">
              PH: 
            </td>
            <td>
              {this.state.profileXi.ph}
            </td>
          </tr>
          <tr>
            <td width="50%">
              Tỷ trọng: 
            </td>
            <td>
              {this.state.profileXi.tyTrong}
            </td>
          </tr>
        </tbody>
      </table>
    )
  }
}

export default withRouter(ProfileXiCard);